<template>




      

  <full-page :options="options" id="fullpage" ref="fullpage"  >
       

              <div class="section" id="section0"    @touchstart="handleDragMove"    
              
        
              
              
              >


                  <div class="top_container in-view">
                        <div class="top_logo top_logo_active">
                            <img src="@/assets/tiffany.svg" alt="">
                      </div>
                  </div> 


              </div>



            <div class="section four_building"  style="background:#edecec">

            <nav > 
              <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
            </nav> 

              <div  class="image_list">

                  <div><img src="@/assets/img/TiffanyHousePhotos1.jpg" /></div>
                  <div><img src="@/assets/img/TiffanyHousePhotos2.jpg" /></div>
                  <div><img src="@/assets/img/TiffanyHousePhotos3.jpg" /></div>
                  <div><img src="@/assets/img/TiffanyHousePhotos4.jpg" /></div>


              </div> 



            </div>



               <div id="section1"  class="section redefine">

                <div class="masker"></div>
              
                 <div class="top_title"  >                          
                    <span  class="top_title_tc top_title_tc_active">
                      <template v-if="this.$store.state.lang==='cn'" >澳門豪宅 重新定義</template>
                      <template v-else >澳门豪宅 重新定义</template>
                       </span>
                  
                    <h1 class="top_title_en top_title_en_active"> REDEFINE LUXURIOUS APARTMENT IN MACAU </h1>
                  </div> 

              
                  
                  

               </div> 


              
              <div class="section video" >

                 <nav> 
                     <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
                </nav> 


                  <div class="videoArea"  >
                    <video ref="videoRef"  id="myVideo"  controls >
                        <source   :src="this.$store.state.videoSource"  type="video/mp4"> 
                              
                                       
                    </video>


                    
                    <button  @click="play_video" class="vjs-big-play-button">
                      <span v-show="hiddenPlay" aria-hidden="true" class="vjs-icon-placeholder"></span>
                    </button>

                   </div> 








              </div>          
             

               <div class="section imagebook"  style="background:#edecec">
            <nav > 
              <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
            </nav> 
                  <div  class="title">
                 <template v-if="this.$store.state.lang==='cn'"><label>名師薈萃</label></template>
                 <template v-else><label >名师荟萃</label></template>
                   <br/>THE WORLD-CLASS DESIGN TEAM
    

                  </div>


                 <div class="section_container">

                   





                            <div  class="left_area flex-column">

                                <div><img  @click="changeImg($event)" id="0" data-bimg="../assets/img/1b.jpg"  src="../assets/img/2.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="1" data-bimg="../assets/img/2b.jpg" src="../assets/img/3.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="2" data-bimg="../assets/img/3b.jpg" src="../assets/img/4.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="3" data-bimg="../assets/img/4b.jpg" src="../assets/img/5.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="4" data-bimg="../assets/img/5b.jpg"  src="../assets/img/1.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="5" data-bimg="../assets/img/6b.jpg" src="../assets/img/6.jpg" /></div>
                                <div><img  @click="changeImg($event)" id="6" data-bimg="../assets/img/7b.jpg" src="../assets/img/7.jpg" /></div>

                                    
                            </div>


                            <div class="right_area ds-view">

                                <div class="big_img"><img  :src="imgBig[change_num]" /></div>



                            </div>


                            <div class="content_area">

                                <p v-if="this.$store.state.lang==='cn'" v-html="section3_1[change_num]"></p>
                                <p v-else v-html="section3_1_sc[change_num]"></p>

                                 

                                 <p v-if="this.$store.state.lang==='cn'" v-html="section3_2[change_num]"></p>
                                 <p v-else v-html="section3_2_sc[change_num]"></p>

                                 <p v-if="this.$store.state.lang==='cn'" v-html="section3_3[change_num]"></p>
                                  <p v-else v-html="section3_3_sc[change_num]"></p>



                            </div>

                  </div>



              </div>   
              
              

              <div class="section map"  id="section4"  style="background-color:#a38a7a">
                
           

                  <div  class="container" style="">


                        <div v-show="(this._isMobile()?false:true)" class="leftSide">
                        
                        </div>    


                        <div class="rightSide">

                          <div class="title"><p>
                            <template v-if="this.$store.state.lang==='cn'">矜罕地段 一應俱全</template>
                            <template v-else>矜罕地段 一应俱全</template>
                          <br/>PERFECTLY LOCATED</p></div>
                            

                          <div class="table">


                              <table>

                                <tbody>
                                  <tr class="title_top"><td colspan="3">
                                    <template v-if="this.$store.state.lang==='cn'">著名學府、公園、綜藝館、博物館，生活文化設施，信步即達</template>
                                    <template v-else>著名学府、公园、综艺馆、博物馆，生活文化设施，信步即达</template>
                                    </td></tr>


                                  <tr  class="title_top">
                                    <td colspan="3">
                                    <template v-if="this.$store.state.lang==='cn'">區內名校網</template>
                                    <template v-else>区内名校网</template>

                                  </td></tr>
                                  <tr>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">聖羅撒英文中學</template>
                                      <template v-else>圣罗撒英文中学</template>
                                    </td>
                                  <td><template v-if="this.$store.state.lang==='cn'">10分鐘</template><template v-else>10分钟</template></td>
                                  <td><img src="@/assets/img/icon_man.svg" /></td></tr>
                                  <tr>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">達聖約瑟大學(皇朝校舍)</template>
                                      <template v-else>达圣约瑟大学(皇朝校舍)</template>
                                    </td>
                                   <td><template v-if="this.$store.state.lang==='cn'">10分鐘</template><template v-else>10分钟</template></td>
                                    <td><img src="@/assets/img/icon_man.svg" /></td></tr>


                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">聖約瑟國際托兒所</template>
                                     <template v-else>圣约瑟国际托儿所</template>
                                  </td>
                                  <td><template v-if="this.$store.state.lang==='cn'">5分鐘</template><template v-else>5分钟</template></td>
                                  <td><img src="@/assets/img/icon_car.svg" /></td>
                                  </tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">聖羅撒女子中學中文部</template>
                                    <template v-else>圣罗撒女子中学中文部</template>
                                  </td>
                                    <td><template v-if="this.$store.state.lang==='cn'">5分鐘</template><template v-else>5分钟</template></td>
                                  <td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">培正中學</template>
                                      <template v-else>培正中学</template>
                                    </td>
                                  <td><template v-if="this.$store.state.lang==='cn'">5分鐘</template><template v-else>5分钟</template></td>
                                  <td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">澳門葡文學校</template>
                                      <template v-else> 澳门葡文学校</template>
                                    </td>
                                 <td><template v-if="this.$store.state.lang==='cn'">5分鐘</template><template v-else>5分钟</template></td>
                                  <td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">陳瑞祺永援中學</template>
                                      <template v-else>陈瑞祺永援中学</template>
                                    </td>
                                  <td>
                                    <template v-if="this.$store.state.lang==='cn'">7分鐘</template>
                                    <template v-else>7分钟</template>
                                  </td>
                                  <td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                   <template v-if="this.$store.state.lang==='cn'">粵華中學</template> 
                                      <template v-else>粤华中学</template> 
                                    </td>
                                    <td>
                                      <template v-if="this.$store.state.lang==='cn'">8分鐘</template>
                                      <template v-else>8分钟</template>
                                    </td>
                                    <td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">嘉諾撒聖心中學</template>
                                    <template v-else>嘉诺撒圣心中学</template>
                                    </td><td>
                                     <template v-if="this.$store.state.lang==='cn'">8分鐘</template>
                                    <template v-else>8分钟</template>
                                      </td><td><img src="@/assets/img/icon_car.svg" /></td></tr> 


                                  <tr class="title_top"><td colspan="3">
                                    <template v-if="this.$store.state.lang==='cn'">毗鄰地標</template>
                                    <template v-else>毗邻地标</template>
                                    </td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">賽車博物館</template>
                                    <template v-else>赛车博物馆</template>
                                    </td><td>
                                      <template v-if="this.$store.state.lang==='cn'">1分鐘</template>
                                      <template v-else>1分钟</template>
                                      </td><td><img src="@/assets/img/icon_man.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">金蓮花廣場</template>
                                     <template v-else>金莲花广场</template>
                                    </td><td>
                                   <template v-if="this.$store.state.lang==='cn'">1分鐘</template>
                                      <template v-else>1分钟</template>
                                      </td><td><img src="@/assets/img/icon_man.svg" /></td></tr>
                                  <tr><td>
                                   <template v-if="this.$store.state.lang==='cn'">宋玉生公園</template> 
                                     <template v-else>宋玉生公园</template> 
                                    </td><td>
                                   <template v-if="this.$store.state.lang==='cn'">10分鐘</template><template v-else>10分钟</template>
                                      </td><td><img src="@/assets/img/icon_man.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">水塘公園</template> 
                                    <template v-else>水塘公园</template> 
                                    </td><td>
                                       <template v-if="this.$store.state.lang==='cn'">3分鐘</template>
                                        <template v-else>3分钟</template>
                                      </td><td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">科學館及海濱休憩區</template>
                                    <template v-else> 科学馆及海滨休憩区</template>
                                    </td><td>
                                      <template v-if="this.$store.state.lang==='cn'">3分鐘</template>
                                      <template v-else>3分钟</template>

                                      </td><td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                    文化中心
                                    </td><td>
                                        <template v-if="this.$store.state.lang==='cn'">3分鐘</template>
                                      <template v-else>3分钟</template>
                                    </td><td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">松山市政公園</template>
                                     <template v-else>松山市政公园</template>

                                  </td><td>
                                     <template v-if="this.$store.state.lang==='cn'">5分鐘</template>
                                      <template v-else>5分钟</template>
                                    </td><td><img src="@/assets/img/icon_car.svg" /></td></tr>
                                  <tr><td>
                                    <template v-if="this.$store.state.lang==='cn'">二龍喉公園</template>
                                        <template v-else>二龙喉公园</template>
                                    </td><td>
                                       <template v-if="this.$store.state.lang==='cn'">8分鐘</template>
                                       <template v-else>8分钟</template>
                                      </td><td><img src="@/assets/img/icon_car.svg" /></td></tr>



                                 
                                  </tbody>

                              </table>


                          </div>

                          <div class="dclare">
                            <p>
                            <template v-if="this.$store.state.lang==='cn'">上述地圖經簡化處理及並非按照比例繪畫，所有資料僅供參考之用。</template>
                            <template v-else>上述地图经简化处理及并非按照比例绘画，所有资料仅供参考之用。</template>
                            </p>
                             <p>
                              <template v-if="this.$store.state.lang==='cn'">上述步行時間及行車時間為非繁忙時段所需時間，僅供參考之用。所有資料不構成不論明示或隱含之要約、承諾、陳述或保證。</template>


                             <template v-else>上述步行时间及行车时间为非繁忙时段所需时间，仅供参考之用。所有资料不构成不论明示或隐含之要约、承诺、陈述或保证。</template>
                            </p>

                          </div>


                        </div>



                  </div>





                
              </div>


             <div class="section map">


                  <div  class="container" style="background-color:white;">

                      <div  v-show="(this._isMobile()?false:true)" class="leftSide building">
                      
                      
                      
                      </div>



                      <div class="rightSide second">


                         <div class="table" >

                                <table >

                                <tbody v-if="this.$store.state.lang==='cn'">
                                  <tr class="title_top"><td colspan="3">澳門作為世界級旅遊城市如此成功，部分歸功於與大灣區和其他世界城市的良好聯繫。從Tiffany House 狄芃尼豪舍可輕鬆前往澳門國際機場、香港國際機場、外港客運碼頭和港珠澳大橋。</td></tr>

                                  <tr class="title_top"><td colspan="3">毗鄰地標</td></tr>
                                  <tr><td>皇朝區商業中心</td><td>5分鐘</td><td><img src="@/assets/img/icon_man_2.svg" /></td></tr>
                                  <tr><td>外港碼頭 </td><td>5分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>
                                  <tr><td>議事亭前地</td><td>5分鐘</td><td><img src="@/assets/img/icon_man_2.svg" /></td></tr>
                                  <tr><td>南灣市中心</td><td>5分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>
                                  <tr><td>港珠澳大橋口岸</td><td>10分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>
                                  <tr><td>澳門國際機場</td><td>10分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>
                                  <tr><td>關閘</td><td>15分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>
                                  <tr><td>澳門青茂口岸</td><td>15分鐘</td><td><img src="@/assets/img/icon_car_2.svg" /></td></tr>                                
                                  </tbody>

                                    <tbody v-else>
                                  <tr class="title_top"><td colspan="3">澳门作为世界级旅游城市如此成功，部分归功于与大湾区和其他世界城市的良好联系。从Tiffany House狄芃尼豪舍可轻松前往澳门国际机场、香港国际机场、外港客运码头和港珠澳大桥。</td></tr>

                                        <tr class="title_top"><td colspan="3">毗邻地标</td></tr>

                                        <tr><td>皇朝区商业中心</td><td>5分钟</td><td><img src="@/assets/img/icon_man_2.svg"/></td></tr>

                                        <tr><td>外港码头</td><td>5分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>

                                        <tr><td>议事亭前地</td><td>5分钟</td><td><img src="@/assets/img/icon_man_2.svg"/></td></tr>

                                        <tr><td>南湾市中心</td><td>5分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>

                                        <tr><td>港珠澳大桥口岸</td><td>10分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>

                                        <tr><td>澳门国际机场</td><td>10分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>

                                        <tr><td>关闸</td><td>15分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>

                                        <tr><td>澳门青茂口岸</td><td>15分钟</td><td><img src="@/assets/img/icon_car_2.svg"/></td></tr>
                                 



                                  </tbody> 




                              </table>


                         </div> 



                     <div class="dclare">
                       <p v-if="this.$store.state.lang==='cn'">上述步行時間及行車時間為非繁忙時段所需時間，僅供參
                            考之用。所有資料不構成不論明示或隱含之要約、承諾、
                            陳述或保證。</p>

                                 <p v-else>上述步行时间及行车时间为非繁忙时段所需时间，仅供参
                            考之用。所有资料不构成不论明示或隐含之要约、承诺、
                            陈述或保证。</p>
                            

                            </div>




                      </div>
                        
                        
                  </div>



             </div> 


           
              <div class="section photobook"  style="background:#edecec">

                 <!-- <header class="header_log"><img  src="../assets/tiffany.svg" /></header> -->
              <swiper
               :style="{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-pagination-color': '#fff',
                }"      
                 @swiper="onSwiper"
                 @slideChange="onSlideChange"         
                :spaceBetween="10"
              :navigation="true" 
                :modules="modules" 
                :thumbs="{ swiper: thumbsSwiper }"
                class="mySwiper2">

        
              <swiper-slide :key="aaa"  v-for="aaa in 34"><img v-lazy="require('../assets/img/photoBook/'+aaa+'.jpg')" /> </swiper-slide>
      

             </swiper>

              <swiper         
              :spaceBetween="10"
              :slidesPerView="(this._isMobile()?2:7)"
              :freeMode="true"
              :modules="[Thumbs]"
                watch-slides-progress
              @swiper="setThumbsSwiper"
              class="mySwiper"
              >
               <swiper-slide :key="aaa"  v-for="aaa in 34"><img v-lazy="require('../assets/img/photoBook/'+aaa+'.jpg')" /> </swiper-slide>
            
              </swiper>  
                
                                


                
              </div>

              <section class="section pdf_down"   style="background:#edecec">

       
            <nav > 
              <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
            </nav> 

                  
                <div class="container">


                 <div class="imagebook">
                     <div class="img"  ><img  src="../assets/img/image_book_bg.jpg" /></div>

                   <div @click="checkForm('http://47.242.226.213:81/e5W1q1/part1/pdf/ImageBook_TiffanyHouseDigital.pdf')">  
                       
                      <label v-if="this.$store.state.lang==='cn'" style="color:#846C32">形象樓書 下載</label>
                       <label v-else style="color:#846C32">形象楼书 下载</label>
                  
                     <img   style="width:20px;height:20px;vertical-align: bottom;"
                      src="../assets/img/download.png" /> 

                     </div>
                  </div>

             

                </div>






              </section>


              <section class="section contact_us"  style="background-color:black">

                  
             <nav > 
              <div class="logo"><img  src="@/assets/tiffany.svg" ></div>
            </nav> 

                

               <div class="container-contact100"  v-if="this.$store.state.lang==='cn'">
                      <div class="wrap-contact100">
                    
                      <span class="contact100-form-title">
                       聯絡我們 
                      </span>
                      <div class="wrap-input100 validate-input" data-validate="請輸入名稱">
                      <input class="input100" type="text" @input="fuxkIn($event)" v-model="form_user_name" name="name" placeholder="稱呼">
                      <span class="focus-input100" ></span>
                      
                      </div>
                      <p v-html="form_user_name_error_mes"></p>

                      <div class="wrap-input100 validate-input" data-validate="請輸入電郵: e@a.x">
                      <input class="input100" type="text" @input="fuxkIn($event)" v-model="form_email"  name="email" placeholder="電郵">
                      <span class="focus-input100"></span>                
                      </div>
                       <p v-html="form_email_error_mes"></p>


                      <div class="wrap-input100 validate-input" data-validate="請輸入電話">
                      <input class="input100" type="number" @input="fuxkIn($event)"  v-model="form_mobile" name="mobile" placeholder="電話">
                      <span class="focus-input100"></span>                    
                      </div>
                       <p v-html="form_mobile_error_mes"></p>


                      <div class="wrap-input100 validate-input" data-validate="請輸入的留言">
                      <textarea class="input100" name="remark" @input="fuxkIn($event)" v-model="form_remark" placeholder="留言"></textarea>
                      <span class="focus-input100"></span>                       
                      </div>
                      <p v-html="form_remark_error_mes"></p>


                        <p v-html="feedback"></p>

                      <div class="container-contact100-form-btn">
                      <button  @click="fuxkIn('commit')" name="commit" class="contact100-form-btn">
                      <span>
                      <i class="fa fa-paper-plane-o m-r-6" aria-hidden="true"></i>
                      發送
                      </span>
                      </button>
                      </div>
                     
                      </div>
                </div>



                 <div class="container-contact100" v-else>
                      <div class="wrap-contact100">
                   
                      <span class="contact100-form-title">
                       联络我们 
                      </span>
                      <div class="wrap-input100 validate-input" >
                      <input class="input100" type="text" @input="fuxkIn($event)" v-model="form_user_name" name="name" placeholder="称呼">
                      <span class="focus-input100" ></span>
                      
                      </div>
                      <p v-html="form_user_name_error_mes"></p>

                      <div class="wrap-input100 validate-input" >
                      <input class="input100" type="text" @input="fuxkIn($event)" v-model="form_email"  name="email" placeholder="电邮">
                      <span class="focus-input100"></span>                
                      </div>
                       <p v-html="form_email_error_mes"></p>


                      <div class="wrap-input100 validate-input" >
                      <input class="input100" type="number" @input="fuxkIn($event)"  v-model="form_mobile" name="mobile" placeholder="电话">
                      <span class="focus-input100"></span>                    
                      </div>
                       <p v-html="form_mobile_error_mes"></p>


                      <div class="wrap-input100 validate-input" >
                      <textarea class="input100" name="remark" @input="fuxkIn($event)" v-model="form_remark" placeholder="留言"></textarea>
                      <span class="focus-input100"></span>                       
                      </div>
                      <p v-html="form_remark_error_mes"></p>


                        <p v-html="feedback"></p>

                      <div class="container-contact100-form-btn">
                      <button  @click="fuxkIn('commit')" name="commit" class="contact100-form-btn">
                      <span>
                      <i class="fa fa-paper-plane-o m-r-6" aria-hidden="true"></i>
                      发送
                      </span>
                      </button>
                      </div>
                    
                      </div>
                </div>









              </section>



              <section class="section declare" id="section8">

                 <!-- <header class="header_log"><img  src="../assets/tiffany.svg" /></header> -->

               <div class="container">


                <div v-show="(this._isMobile()?false:true)" class="leftSide"></div>



                <div class="rightSide">


                   <div  class="title"><span>
                    <template v-if="this.$store.state.lang==='cn'">狄芃尼豪舍 - 發展商免責聲明</template>
                    <template v-else>狄芃尼豪舍 - 发展商免责声明</template>

                    </span></div>
                  

                          <div    class="content">

                          <template v-if="this.$store.state.lang==='cn'">

                          <p>本網頁內的所有資料,包括任何圖片、插圖、透視圖、 模型、設計圖、繪圖、文字描述或其他資料,僅供參考或識別之用,並不構成或被視為發展商的任何明示或隱含的要約承諾或保證。圖片或經電腦模擬及簡化處理,並不按比例。所有資料均以承諾買賣合約的條款及條件為準。</p>
                          <p>發展物業的詳情包括所述的資料須經當地政府部門的批准。發展商保留權利在無須給予任何通知的情況下,按當地政府部門要求或其他原因,改動及撤銷任何有關樓宇的設計、規格、特色、平面圖、時間表、上蓋物業之分佈、 物料以及任何有關設備或服務之供應或其用途。</p>
                          <p>會所設施、佈局、間隔、裝飾及設計以入伙時所提供為準。</p>
                          <p>住客會所附屬康樂設施於入伙時未必能即時啟用。</p>

                          <p>部份禮賓服務及會所設施須額外收費。</p>

                          <p>發展商保留一切權利,並無須給予事先通知,以類似質素及等級的材料代替於標準用料及設備中所列的擬用材料。</p>

                          <p>在此建議各準買家親身到訪物業周圍以充份了解其環境,如有疑問或欲知個別內容之詳情,請向其銷售代理或有關行業之專業人士詢問查證。</p>

                          <p>本網頁中英版本文字若有差異,一切內容以中文版本為準。</p>

                          <p>發展商:中國星創新發展有限公司</p>
                          <p>物業登記編號: 22618</p>
                          <p>現有上蓋工程准照的編號: 244/2018</p>
                          <p>預計交樓日期:預計2022年下半年</p>
                          <p>承建商:成龍工程有限公司</p>
                          <p>地段:澳門外港填海區-6街區C,D及E地段</p>
                          <p>物業地址：</p>
                          <p>澳門半島高美士街302-A - 388-D</p>
                          <p>銷售中心</p>
                          <p>澳門高美士街336, 348, 354-A, 354-B號地下及一樓D, E, F座</p>
                          <p>(853) 2882 8883</p>
                          <p>admin@chinastarmgt.onmicrosoft.com</p>
                          <p>香港灣仔告士打道42-46號捷利中心地下3號舖</p>
                          <p>(852) 9688 8383</p>
                          <p>銷售及市場策劃: 利嘉閣大灣區置業顧問</p>
                          <p>廣告設計及策劃：makesense co. ltd</p>

                          <p>詳情請參閱預約買賣合同、 售樓說明書及價單。</p>

                          <p>

                              <img class="chinaStart" src="@/assets/img/chinaStart.svg"  />

                          </p>

                          </template>

                          



                      </div>


                        <div  class="content">

                          <template v-if="this.$store.state.lang==='sc'">

                            <p>本网页内的所有数据，包括任何图片、插图、透视图、模型、设计图、绘图、文字描述或其他数据，仅供参考或识别之用，并不构成或被视为发展商的任何明示或隐含的要约承诺或保证。图片或经计算机仿真及简化处理，并不按比例。所有数据均以承诺买卖合约的条款及条件为准。</p>

                            <p>发展物业的详情包括所述的数据须经当地政府部门的批准。发展商保留权利在无须给予任何通知的情况下，按当地政府部门要求或其他原因，改动及撤消任何有关楼宇的设计、规格、特色、平面图、时间表、上盖物业之分布、物料以及任何有关设备或服务之供应或其用途。</p>

                            <p>会所设施、布局、间隔、装饰及设计以入伙时所提供为准。</p>

                            <p>住客会所附属康乐设施于入伙时未必能即时启用。</p>

                            <p>部份礼宾服务及会所设施须额外收费。</p>

                            <p>发展商保留一切权利，并无须给予事先通知，以类似素质及等级的材料代替于标准用料及设备中所列的拟用材料。</p>

                            <p>在此建议各准买家亲身到访物业周围以充份了解其环境，如有疑问或欲知个别内容之详情，请向其销售代理或有关行业之专业人士询问查证。</p>

                            <p>本网页中英版本文字若有差异，一切内容以中文版本为准。</p>

                            <p>发展商：中国星创新发展有限公司</p>

                            <p>物业登记编号：22618</p>

                            <p>现有上盖工程准照的编号：244/2018</p>

                            <p>预计交楼日期：预计2022年下半年</p>

                            <p>承建商：成龙工程有限公司</p>

                            <p>地段：澳门外港填海区-6街区C，D及E地段</p>

                            <p>物业地址：</p>

                            <p>澳门半岛高美士街302-A - 388-D</p>

                            <p>销售中心</p>

                            <p>澳门高美士街336，348，354-A，354-B号地下及一楼D，E，F座</p>

                            <p>（853）2882 8883</p>

                            <p>香港湾仔告士打道42-46号捷利中心地下3号铺</p>

                            <p>（852）9688 8383</p>

                            <p>销售及市场策划：利嘉阁大湾区置业顾问</p>

                            <p>广告设计及策划：makesense co. ltd</p>

                            <p>详情请参阅预约买卖合同、售楼说明书及价单。</p>

                             <p>

                             <img class="chinaStart" src="@/assets/img/chinaStart.svg"/>

                            </p>

                            </template>

                           





                  </div>




                </div>



               






    



          </div>  

              </section>



              




        </full-page>

    
    <div  @click="arrowDown"  v-show="arrowShow" class="position-absolute text-center cursor-pointer page-down-arrow"><svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="65" height="42" viewBox="0 0 52 33.75"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M26,18.35.63,2.5A1.35,1.35,0,0,1,.21.64,1.34,1.34,0,0,1,2.07.21L26,15.16,49.93.21a1.34,1.34,0,0,1,1.86.43,1.35,1.35,0,0,1-.43,1.86Z" fill="#fff"></path><path d="M26,33.75.63,17.9a1.35,1.35,0,0,1,1.44-2.29L26,30.57l23.93-15a1.35,1.35,0,0,1,1.43,2.29Z" fill="#fff"></path></g></g></svg></div>

    <button @click="backToTop" v-show="ToTop"  id="myBtn" title="Go to top"></button>

</template>

<script>

  // Import Swiper Vue.js components

  import DiyModalVue from './DiyModal.vue';

import { ref } from 'vue';
  // Import Swiper styles
  import 'swiper/css';
  
  import "swiper/css/free-mode"
  import 'swiper/css/navigation';
  import 'swiper/css/pagination';
  import 'swiper/css/scrollbar';
  import "swiper/css/thumbs"

  import 'viewerjs/dist/viewer.css'

  //import { api as viewerApi } from "v-viewer"
  // import Swiper core and required modules

import {FreeMode,Navigation,Thumbs} from 'swiper';
 import { Swiper, SwiperSlide } from 'swiper/vue';



import axios from 'axios'

export default {

  components: {
    Swiper,
    SwiperSlide
    

    
   
    
},
 setup() {
   const thumbsSwiper = ref(null);
      const setThumbsSwiper = (swiper) => {
        thumbsSwiper.value = swiper;
      };
       const onSlideChange = () => {
        console.log('slide change');
      };
       const onSwiper = (swiper) => {
        console.log(swiper);
      };


     const isShow = ref(false)

    

    return {

      modules: [Navigation,Thumbs],
       Thumbs,
        thumbsSwiper,
        setThumbsSwiper,
        FreeMode,
        Navigation,
        onSlideChange,
        onSwiper
        
   
      

    };
  },
  name: 'SectionPage',
  props: {
    msg: String
  },data () {
      return {
        options: {
        
          showFrom:false,
          licenseKey: 'YOUR_KEY_HERE',
          afterLoad: this.afterLoad,
          afterResponsive:this.afterResponsive,
          afterSlideLoad:this.afterSlideLoad,
         // scrollOverflow: true,
         // scrollBar: false,
          menu: '#menu',
          // responsiveWidth: 750,
        //  navigation: true,
          anchors: [ 'page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11'],
          //sectionsColor: ['black', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', '#ee1a59', '#2c3e4f', '#ba5be9', '#b4b8ab'],
           credits: {
        "enabled": false
      }
        },arrowShow:true,
        ToTop:false,
       info_api:'http://47.242.226.213:8084/ir',
       mail_api:'http://47.242.226.213:8081/mailSend',
       // scrollOverflow: false,
      // scrollBar: false,
        //responsiveSlides: false,
        // responsiveWidth: 750,
	
       // autoScrolling: false,
        imgList:[''],
        hiddenPlay:true,
        targetImg:require('../assets/img/2b.jpg'),
        section3_1:[
          'ARQUITECTONICA 作為打造全球眾多傑出建築的建築匠人，Tiffany House 狄芃尼豪舍是它首個澳門項目， 以經驗和巧思淬鍊出項目獨特的美感。',
           '『LITCHVISION』—扎根德國並屢獲殊榮的燈效顧問公司，為整個Tiffany House 狄芃尼豪舍妝點令人嘆為觀止的燈光效果。',
           '著名景觀設計師 Adrian L. Norman Limited以多種樹木、水景和野花床等植物擺設搭配，為建築增添悠悠綠意。',
        'Tiffany House 狄芃尼豪舍將環保融入生活，推行持續綠色生活概念。 由曾參與香港多個頂級豪宅項目的希文森玻璃幕牆顧問有限公司設計的玻璃幕牆，採用雙層中玻璃給低輻射玻璃塗層，除了體現現代美學，更有效阻隔噪音及減低輻射，減少空調使用量的同時有效調節室內溫度，達致冬暖夏涼的效果。',
          '張叔平先生在電影剪輯、美術指導以及電影服裝設計領域等享負勝名，名譽全球。過往除獲得香港電影金像獎多個獎項，亦13次獲得金馬獎的最佳美術指導及最佳剪接等電影技術獎。張先生除了在電影世界一直耕耘之外，亦有為著名影星及名人擔任室內設計師，將他的美感理念和獨特見解融合到住宅和別墅室內設計當中。' ,
         '得獎星級設計師沈墨主理的AT時上建築空間設計，為Tiffany House 狄芃尼豪舍各個單位構建不同生活風格，打造現代 「建築 X 生活」美學，為每一位尊貴住戶提供訂製室內設計方案。',
         '擁有40多年卓越聲譽的國際工程顧問公司Buro Happold，致力於為Tiffany House 狄芃尼豪舍提供富有創意的且具有價值的建築結構。'
        ],
         section3_1_sc:[
        'ARQUITECTONICA作为打造全球众多杰出建筑的建筑匠人，Tiffany House狄芃尼豪舍是它首个澳门项目，以经验和巧思淬炼出项目独特的美感。',
'『LITCHVISION』—扎根德国并屡获殊荣的灯效顾问公司，为整个Tiffany House狄芃尼豪舍妆点令人叹为观止的灯光效果。',
'著名景观设计师Adrian L. Norman Limited以多种树木、水景和野花床等植物摆设搭配，为建筑增添悠悠绿意。',
'Tiffany House狄芃尼豪舍将环保融入生活，推行持续绿色生活概念。由曾参与香港多个顶级豪宅项目的希文森玻璃幕墙顾问有限公司设计的玻璃幕墙，采用双层中玻璃给低辐射玻璃涂层，除了体现现代美学，更有效阻隔噪音及减低辐射，减少空调使用量的同时有效调节室内温度，达致冬暖夏凉的效果。',
'张叔平先生在电影剪辑、美术指导以及电影服装设计领域等享负胜名，名誉全球。过往除获得香港电影金像奖多个奖项，亦13次获得金马奖的最佳美术指导及最佳剪接等电影技术奖。张先生除了在电影世界一直耕耘之外，亦有为著名影星及名人担任室内设计师，将他的美感理念和独特见解融合到住宅和别墅室内设计当中。',
'得奖星级设计师沈墨主理的AT时上建筑空间设计，为Tiffany House狄芃尼豪舍各个单位构建不同生活风格，打造现代「建筑X生活」美学，为每一位尊贵住户提供订制室内设计方案。',
'拥有40多年卓越声誉的国际工程顾问公司Buro Happold，致力于为Tiffany House狄芃尼豪舍提供富有创意的且具有价值的建筑结构。'
        ],
        section3_2:[
          '著名設計項目囊括全球，包括紐約的The Westin Hotel、巴黎的 Microsoft Europe HQ 、首爾的 International Finance Centre、上海的Agricultural Bank of China HQ和香港的 Mount Parker Residence。',
          '參與的項目遍佈全球，包括德國的Leica Camera, Wetzlar、英國的One Nine Elms, London、新加坡的Changi International Airport Terminal 4等。',
          '擁有超過30年的經驗，他曾參與香港多個設計項目，例如傲瀧、嘉里酒店、新世界機場辦公樓項目(Skycity), 及樹屋(Timber House)',
          '工作的重點在亞洲及中東地區，曾負責項目包括香港的Azura、21 Borrett Road和香港科學園。',
         
          '在Tiffany House 狄芃尼豪舍，張叔平的設計美學概念展現於會所的每一個角落，在簡約中盡顯奢華，體現細節與美感的追求。',
          '沈墨<br/>室內設計師<br/>中國及歐美多項金獎設計師',
          
          '參與的項目遍佈全球，一直以來獲獎無數，曾獲得2020年國際建築獎的兩項優勝者獎項。'
          
          
        ],section3_2_sc:[
         '著名设计项目囊括全球，包括纽约的The Westin Hotel、巴黎的Microsoft Europe HQ、首尔的International Finance Centre、上海的Agricultural Bank of China HQ和香港的Mount Parker Residence。',
'参与的项目遍布全球，包括德国的Leica Camera，Wetzlar、英国的One Nine Elms，London、新加坡的Changi International Airport Terminal 4等。',
'拥有超过30年的经验，他曾参与香港多个设计项目，例如傲泷、嘉里酒店、新世界机场办公楼项目(Skycity), 及树屋(Timber House)',
'工作的重点在亚洲及中东地区，曾负责项目包括香港的Azura、21 Borrett Road和香港科学园。',
'在Tiffany House狄芃尼豪舍，张叔平的设计美学概念展现于会所的每一个角落，在简约中尽显奢华，体现细节与美感的追求。',
'沈墨<br/>室内设计师<br/>中国及欧美多项金奖设计师',
'参与的项目遍布全球，一直以来获奖无数，曾获得2020年国际建筑奖的两项优胜者奖项。'
        ],




        section3_3:[
              'Bernardo Fort-Brescia<br/>ARQUITECTONICA創辦人',
              'Dr Karsten Ehling<br/>LITCHVISION DESIGN GMBH 創辦人及總經理',
              
          'Adrian L Norman<br/>ADRIAN L. NORMAN LIMITED 總經理',
          
          'Andreas Hiersemenzel<br/>希文森幕牆顧問有限公司總經理',//5
          '',
      
          
          '共生思想生態設計應用者<br/>時上建築空間設計事務所創始人',
         
          ''


        ],
         section3_3_sc:[
              'Bernardo Fort-Brescia<br/>ARQUITECTONICA创办人',

'Dr Karsten Ehling<br/>LITCHVISION DESIGN GMBH创办人及总经理',



'Adrian L Norman<br/>ADRIAN L. NORMAN LIMITED总经理',



'Andreas Hiersemenzel<br/>希文森幕墙顾问有限公司总经理',//5

'',



'共生思想生态设计应用者<br/>时上建筑空间设计事务所创始人',



''
        ],
        change_num:0,
        imgBig:[
         
          require('../assets/img/2b.jpg'),
          require('../assets/img/3b.jpg'),
        
      
          require('../assets/img/4b.jpg'),
          require('../assets/img/5b.jpg'),

         
        
            require('../assets/img/1b.jpg'),
         
            require('../assets/img/6b.jpg'),
              require('../assets/img/7b.jpg'),

        ] ,open: true
        ,preview_images: [
           {
          //'src':'https://picsum.photos/200/200?random=3',
          'data-source':require('@/assets/img/local_map.png')
        },
        {
          //'src':'https://picsum.photos/200/200?random=4',
          'data-source':require('@/assets/img/great_bay_area_map.jpg')
        }
        ],
        form_user_name:'',
        form_mobile:'',
        form_email:'',
        form_remark:'',
        form_user_name_error_mes:'',
        form_mobile_error_mes:'',
        form_email_error_mes:'',
        form_remark_error_mes:'',
         isLoading: false,
         feedback:'',
         phoneBook:[]
       
        
      }
    },
  created() {





     



  },mounted:function(){

   
    
    var oMedia = document.getElementById("myVideo");

    var cur = this

    oMedia.addEventListener("play",function(data){  

      console.log('play')
      document.querySelector('audio').pause(); 
      cur.$store.state.soundOn = false
     
      
       
    }); 
      oMedia.addEventListener("pause",function(){  
       console.log('myVideo  pause')
        document.querySelector('audio').play();
           cur.$store.state.soundOn = true
          // cur.changeSate(false)
        
    }); 

      oMedia.addEventListener("end",function(){  
       console.log('myVideo  end')
       document.querySelector('audio').play();
          cur.$store.state.soundOn = true
    });  



  }
  ,
  methods:{


    PlayBgm (){

       var promise = document.querySelector('audio').play();
    

          if (promise !== undefined) {
          promise.then(_ => {
            // Autoplay started!
            console.log('Autoplay started!')
               this.$store.state.soundOn = true
          }).catch(error => {
            // Autoplay was prevented.
            // Show a "Play" button so that user can start playback.
            console.log(error)
          });
          } 



    },

    async SendEail() {


  
  this.feedback =''

   setTimeout(async () => {

    
    
    const emailjs = require("@emailjs/browser");
const templateParams = {
    name: this.form_user_name,
    
    notes: 'Check this out!',
    message:'Customer name:'+this.form_user_name +',+email :'+this.form_email +',mobile:' + this.form_mobile +',message:' + this.form_remark
};

emailjs.send('service_3y8lv74','template_ly2tnmq', templateParams, 'AtlRF3rKqyHICU04o')
	.then((response) => {
    this.$store.state.isLoading = false
	   //console.log('SUCCESS!', response.status, response.text);
     this.feedback = '郵件提交成功'
	}, (err) => {
    this.$store.state.isLoading = false
	   //console.log('FAILED...', err);
     this.feedback = '郵件提交失敗' 
	});


        /*    const req_json = { 
                subject : "Tiffany website feedback",
                 text:"Tiffany website feedback",
                html : 'Customer feedback form email:'+this.form_email +',mobile:' + this.form_mobile +',message:' + this.form_remark  }
                axios.get(this.mail_api,{params:req_json}).then((response) => {
        console.log(response.data)
        this.$store.state.isLoading = false
        if(response.data.code===101){
            this.feedback = '郵件提交成功'
         
        }else{
         this.feedback = '郵件提交失敗' 
        }
        
      })  */


      },2000)
   

      },
  fuxkIn(e){


  this.feedback =''
 
      const current_target = e!=='commit'?e.target.getAttribute("name"):e

       //console.log(current_target)

    if(current_target==='name' || current_target==='commit'){
      if(this.form_user_name===''){
       
        this.form_user_name_error_mes = '稱呼不能爲空'
        return
      }else{
        this.form_user_name_error_mes = ''
        
      }
    }

    if(current_target==='email' || current_target==='commit'){ 
      if(this.form_email===''){
       
          this.form_email_error_mes = '電郵不能爲空'
        return
      }else{
        this.form_email_error_mes = ''
        
      }

    }
    
    
    if(current_target==='mobile' || current_target==='commit'){ 

        if(this.form_mobile==='' ){
        
          this.form_mobile_error_mes = '電話不能爲空'
        return
        }else{
        this.form_mobile_error_mes = ''
        
        }

        console.log('form_mobile:'+ new String(this.form_mobile).length)

        if( new String(this.form_mobile).length>13   ){
       
          this.form_mobile_error_mes = '電話格式正確為 : 85312345678[區號]+[號碼]'
        return
        }else{
         this.form_mobile_error_mes = ''
        }

    } 

 

        
    if(current_target==='remark' || current_target==='commit'){ 
      if(this.form_remark===''){
            console.log('em')
              this.form_remark_error_mes = '留言不能爲空'
            return
          }else{
              this.form_remark_error_mes = ''
              
          }

    }


    if(e==='commit'){
        console.log('commit')
         this.$store.state.isLoading = true



         setTimeout(() => {
    this.SendEail();
}, 3000 );
    
  /*  const req_json = { name : this.form_user_name,
                mobi  : this.form_mobile,
                email:this.form_email,remark:this.form_remark     }
                axios.get(this.info_api,{params:req_json}).then((response) => {
        console.log(response.data)
      })   */

    }


   


    
    

  }, 


 _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

      show (index) {
        
       this.$viewerApi({
          options: {
            toolbar: true,
            url: 'data-source',
            initialViewIndex: index
          },
          images: this.preview_images,
        })
      },

    checkForm:function(src){


      const sign_email =  localStorage.getItem('sign_email')


      console.log(localStorage)

      if(sign_email===null){
        this.$store.state.isShowModal = true
        this.$store.state.download = src 
         // console.log('null')
      }else{
          //console.log('no null')
          const down = src

         var el = document.createElement("a");
				document.body.appendChild(el);
				el.href = down; //url 是你得到的连接
				el.target = '_new'; //指定在新窗口打开
				el.click();
				document.body.removeChild(el);
      }

  return;

 // this.$store.state.count  = 3
this.$store.state.isShowModal = true
this.$store.state.download = src 
    

    },
     hideModal() {
     this.$store.state.isShowModal = true 
    },
    arrowDown:function(){
    //  console.log('arrowdown')
       this.$refs.fullpage.api.moveSectionDown();
      

    },backToTop:function(){

//console.log('backToTop')
  this.$refs.fullpage.api.moveTo('page1', 0);
  this.$data.ToTop = false
    }
    ,afterLoad: function (origin,destination,direction) {



  /*     const music =  document.getElementById('bg_audio')
      
      if(this.$store.state.soundOn === true){
          music.play()
      }else{
          music.pause()
      } */
    
      /*   var promise = document.querySelector('audio').play();


      if (promise !== undefined) {
      promise.then(_ => {
        // Autoplay started!
        console.log('Autoplay started!')
      }).catch(error => {
        // Autoplay was prevented.
        // Show a "Play" button so that user can start playback.
        console.log(error)
      });
        } */
    


        // origin 起点 destination终点 direction方向 固定写法
      this.navIndex = destination.index; 
      //destination.index代表对应页面index(从0开始)
      //拿到对应页面的index就可以进行操作
      //console.log(direction)
      if (destination.index > 0) {
          this.$data.arrowShow = false
          this.$data.ToTop = true
          //this.$store.state.isTopShow = true

         /*  if(destination.index===2 || destination.index===5 || destination.index===6 || destination.index===7 || destination.index===10 ){
          this.$store.state.isTopShow = false
          } */

      }

       /*    const music =   document.getElementById('audio')
          music.muted = false
          music.play() */

      if ( destination.index ===0) {
        this.$data.arrowShow = true
        this.$data.ToTop = false
      //  this.$store.state.isTopShow = false
      }
   // console.log(destination.index)

      if(direction==='up'){
        //console.log('up')
      }
      
    },afterSlideLoad: function(slideIndex, index){ 
      //console.log(slideIndex+','+index)
  } ,play_video :function(){

    // console.log('play_video')
 this.$refs.videoRef.play();
 this.$data.hiddenPlay = false
  },changeImg :function (event){
   //   console.log(event.currentTarget.src)
    //  console.log(event.currentTarget.id)
      this.$data.change_num = event.currentTarget.id
     // console.log( event.target.getAttribute('data-bimg'))
      
      const _src =  event.target.getAttribute('data-bimg')//require( event.target.getAttribute('data-bimg'))
       //../assets/img/5b.jpg
      
      this.$data.targetImg = _src
  }

  }
}
</script>




<style scoped>


body{
  background-color:#f2f2f2
}

/*---------------------------------------------*/
a {
	
	font-size: 14px;
	line-height: 1.7;
	color: #666666;
	margin: 0px;
	transition: all 0.4s;
	-webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
}

a:focus {
	outline: none !important;
}

a:hover {
	text-decoration: none;
}




.wrap-input100 p{

text-align: left;

}

/* 
p {
	
	font-size: 14px;
	line-height: 1.7;
	color: #666666;
	margin: 0px;
} */

ul, li {
	margin: 0px;
	list-style-type: none;
}


/*---------------------------------------------*/
input {
	outline: none;
	border: none;
}

input[type="number"] {
    -moz-appearance: textfield;
    appearance: none;
    -webkit-appearance: none;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

textarea {
  outline: none;
  border-width: 1px;
    border-style: solid;
    border-color: rgb(191, 191, 191);
}

textarea:focus, input:focus {
  border-color: transparent !important;
}

input::-webkit-input-placeholder { color: #bdbdd3;}
input:-moz-placeholder { color: #bdbdd3;}
input::-moz-placeholder { color: #bdbdd3;}
input:-ms-input-placeholder { color: #bdbdd3;}

textarea::-webkit-input-placeholder { color: #bdbdd3;}
textarea:-moz-placeholder { color: #bdbdd3;}
textarea::-moz-placeholder { color: #bdbdd3;}
textarea:-ms-input-placeholder { color: #bdbdd3;}

/*---------------------------------------------*/
button {
	outline: none !important;
	border: none;
	background: transparent;
}

button:hover {
	cursor: pointer;
}

iframe {
	border: none !important;
}


/*---------------------------------------------*/
.container {
	/* max-width: 1200px; */
}





/*//////////////////////////////////////////////////////////////////
[ Contact ]*/

.container-contact100 {
  width: 100%;  
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  position: relative;
  background-color: black;
}

.wrap-contact100 {
  width: 550px;
  background: transparent;
  padding: 50px 0px 0px 0px;
}


/*==================================================================
[ Form ]*/

.contact100-form {
  width: 100%;
}

.contact100-form-title {
  display: block;
  
  font-size: 30px;
  color: #fff;
  line-height: 1.2;
  text-transform: uppercase;
  text-align: center;
  padding-bottom: 30px;
}

/*------------------------------------------------------------------
[ Input ]*/

.wrap-input100 {
  width: 100%;
  background-color: #fff;
  border-radius: 31px;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.input100 {
  position: relative;
  display: block;
  width: 100%;
  background: #fff;
  border-radius: 31px;
 
  font-size: 18px;
  color: #8f8fa1;
  line-height: 1.2;
}


/*---------------------------------------------*/
input.input100 {
  height: 62px;
  padding: 0px 10px 0 35px;
}


/*------------------------------------------------------------------
[ Focus Input ]*/

.focus-input100 {
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  border-radius: 31px;
  background-color: #fff;
  pointer-events: none;
  
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.input100:focus + .focus-input100 {
  width: calc(100% + 20px);
}

/*------------------------------------------------------------------
[ Button ]*/
.container-contact100-form-btn {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 30px;
}

.contact100-form-btn {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  min-width: 150px;
  height: 62px;
  background-color: transparent;
  border-radius: 31px;

  font-size: 16px;
  color: #fff;
  line-height: 1.2;
  text-transform: uppercase;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
  position: relative;
  z-index: 1;
}

.contact100-form-btn::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  border-radius: 31px;
  background-color: #846C32;
  pointer-events: none;
  
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.contact100-form-btn:hover:before {
  background-color: #C4A24D;
  width: calc(100% + 20px);
}




/*------------------------------------------------------------------
[ Alert validate ]*/

.validate-input {
  position: relative;
}

.alert-validate::before {
  content: attr(data-validate);
  position: absolute;
  z-index: 1000;
  max-width: 70%;
  background-color: #fff;
  border: 1px solid #c80000;
  border-radius: 14px;
  padding: 4px 25px 4px 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 10px;
  pointer-events: none;

  color: #c80000;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;

  visibility: hidden;
  opacity: 0;

  -webkit-transition: opacity 0.4s;
  -o-transition: opacity 0.4s;
  -moz-transition: opacity 0.4s;
  transition: opacity 0.4s;
}

.alert-validate::after {
  content: "\f06a";
  font-family: FontAwesome;
  display: block;
  position: absolute;
  z-index: 1100;
  color: #c80000;
  font-size: 16px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 16px;
}

.alert-validate:hover:before {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 992px) {
  .alert-validate::before {
    visibility: visible;
    opacity: 1;
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* 
#section1::after ,.section.video::after{
content: '';
position: absolute;
left: 1%;
top: 0%;
width:100px;
height: 100px;
background-image: url(../assets/tiffany.svg);
background-repeat: no-repeat;
background-size: 100% 100%;
  z-index: 9999999999999999;
}  */


#myVideo{
		/* position: absolute; */
		right: 0;
		bottom: 0;
		top:0;
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
background-color: black; 
background-position: center center;
background-size: contain;
object-fit: cover;
z-index:3;
	}

.section{

background-size:cover;

}
.position-absolute {
    position: absolute !important;
}
.page-down-arrow {
    left: 0;
    right: 0;
    bottom: 20px;
    z-index: 1;
}


 .p-heading {
 z-index: 1;
    color: #846C32;
    display: inline-block;
    animation: myload 0.5s linear infinite;

    width: 100%; 

}

.fp-watermark{
  display: none;
}
.page-down-arrow{left:0;right:0;bottom:20px;z-index:1}
.page-down-arrow .arrow{filter:drop-shadow(0px 3px 5px rgba(0,0,0,0.5))}
@media (max-width: 1023.98px){.page-down-arrow .arrow{width:30px;height:15px}}




.section.video{
display: flex;
justify-content: center;
align-items: center;
background-color: #000;
}

.imagebook{


  justify-content: center;
  align-items: center;
  
}




.left_area{
  width: 15%;
  display: flex !important;
  margin-right: 1%;
}

.left_area>div{
 /*  height: 80px; */
}

.left_area img{
   /*  width: 100%; */
  object-fit: contain;
  height: 80px;
}


.left_area>div img:hover{
   box-shadow:0px 4px 21px 4px #846C32;
 
} 



.right_area
{
  width: 45%;
}

.content_area{
  width:40%;
  justify-content: baseline;

  font-size: 13px;
  text-align: left;
}

.content_area p{
  padding-bottom: 10%;
}


.section_container{
  display: flex;
  width: 85%;
  /* max-height: 540px; */
  align-items: center;
}

#myBtn {
 
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
  background-image:url(../assets/img/backBtn_1.png) ;
  background-size:cover ;
}

#myBtn:hover {
   background-color: #555; 
   background-image:url(../assets/img/backBtn_2.png) ;
} 

.section img:not(.imagebook img,.map img){

    background-size: cover;
    width: 100%;
    

}



.big_img img{
    max-height: 560px;
    object-fit:scale-down;
    width: -webkit-fill-available;


}


.left_area>div{

  /* width: 100% !important; */
}


.videoArea  .vjs-big-play-button {
    z-index: 2;
    font-size: 6em;
    line-height: 118px;
    height: 118px;
    width: 118px;
    border: 0;
    color: rgba(255,255,255,0.7);
    background-color: transparent !important;
    left: 50%;
    top: 50%;
    margin-left: -59px;
    margin-top: calc((-118px / 2));
}

.videoArea  .vjs-big-play-button .vjs-icon-placeholder:before {
    content: "";
    background-image: url(../assets/img/btn_play.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 40px;
}

.ds-view {
    margin-right: 2.09205%;
    flex: 0 0 53.0783%;
    max-width: 53.0783%;
}


.videoArea  .vjs-big-play-button .vjs-icon-placeholder:before{

   position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
 }








#section1 img{
color: #fff;
    
  

}


.videoArea{
  width: 50%;
  margin: 0 auto;
}


.localMap{
display: flex;
flex-direction: column;

}

.localMap .title{
width:100%;

}
.localMap img{
  width:100%;
  height: 100%;
  object-fit: cover;
}
/* .local>div,.bay>div{
  width:50%;
  float: left;

} */

.local,.bay{
  display: flex;
 justify-content: center;
}
.local>div{
  width:45%;
 
}

.bay{
  margin-top: 1.5%;
}


.bay>div:nth-child(2){
width: 75%;
    padding-right: 10%;
}

.local img,.bay img{
  width: 260px;
  height: 225px;
}


.local h6 {
  margin-top: 0%;
  line-height: normal;
}
 

.local img,.bay img{
  border-radius:50px;
 
}




.localMap>div:nth-child(1){

width: 100%;
}



.localMap .local{
  width:100%;
}


.localMap .content{
  line-height:20px;
  font-size: 0.8rem;
  text-align: justify;
}






.vidbg-container video {
    position: absolute;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 0.25s opacity ease-in-out;
    max-width: none;
    opacity: 0;
}

.swiper {
  width: 100%;
  height: 100%; 
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */
  background-color: black;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%; 
  object-fit: contain;
}

body {
  background: #000;
  color: #000;
}


.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
 
  width: 60%;
  height: 60%;

}
.mySwiper2  .swiper-slide{

background-position: center;
    background-size: cover;


}


.mySwiper2 img{
  width: 100%;
  display: block;
}
.mySwiper  {
  width:60%;
  height: 15%;
  
}

.mySwiper .swiper-slide{


  box-sizing: border-box;
  padding: 10px 0;

  
}



.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.pdf_down .container{
  width: 90%;
  margin:  0 auto;
}

.pdf_down .container>div{
 /* width: 80%;
  
   padding: 5%; */
}


#section8 .title{
font-size: 30px;

    color: #846C32;
    line-height: 1.2;
    text-transform: uppercase;
    text-align: center;
    padding-bottom: 30px;
    padding-top: 30px;
}

#section8 {

font-size: 0.8rem;

text-align:left;
white-space: normal !important;

}
.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}



.fcf-body {
    margin: 0;
    font-family: -apple-system, Arial, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
    padding: 30px;
    padding-bottom: 10px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    max-width: 100%;
}
.fcf-form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    outline: none;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.fcf-btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}





.contact_us{
  display: block;
  
}

.contact_us .form{
display: flex;
    align-items: center;
    justify-content: center;
    
   
    padding: 2%;
   
}
.contact_us table  input{

border: 1px solid ;
width: 100%;
  
}


table textarea {
    width: 100%;
    font-size: 1em;
   
    color: rgb(87, 87, 87);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(191, 191, 191);
    border-image: initial;
    padding: 8px;
}


.contact_us table{
  border-collapse: separate;
    border-spacing: 0px 10px;
    text-align: left;
}

.contact_us input {
  
    line-height: 31px;
    position: relative;
    font-size: 1em;
   
    color: rgb(87, 87, 87);
    border-width: 1px;
    border-style: solid;
    border-color: rgb(191, 191, 191);
    border-image: initial;
    padding: 0px 10px;
    
}



.header_log{
  height: 100px;
 text-align: left;
 
 
}
.header_log  img{
width:100px;
height: 100px;
padding-left:1% ;
}


.map .header_log .logo {
  display: flex;
  justify-content: flex-start;
}




.section.map .header_log {
  display: flex;
}
.section.map .header_log .title{
display: flex;
    width: 100%;
    position: absolute;
    justify-content: center;
    align-items: center;
    height: 100px;
}


.logo .chinaStart{
  margin-top:1%  ;
  height: 50px;
  width: auto;
}


#section8  .content {
  
  box-sizing: border-box;
}






@media screen and (max-width: 890px), screen and (max-height: 400px){




textarea{
padding:11px 15px 37px 15px
}

.section>div{
  width: 98%;
  margin: 0 auto;
}


.localMap .content{
  font-size: 16px;
}
p{
  font-size: 16px;
  
}

.wrap-contact100 p{
  color: #fff;
  
}

.wrap-contact100{
    width: auto;
    background: transparent;
    /* padding: 60px 0px 0px 0px; */
}
input.input100 {
    height: 55px;
    text-indent: 10px;
}

#section8 .title{
  font-size: 20px;
}

.p-heading{
  font-size: 10px;
}
.section>div:not(#section1>div,.videoArea,.logo,.contact_us>div,.imagebook .title,.imagebook .section_container,.image_list){
  margin-top: 60px;
}

.section .image_list{
  margin-top:90px;
}

.imagebook .title{
  margin-top: 120px;
}

.local>div, .bay>div{
    width: 100%;
}


.local, .bay{
   flex-direction: column;
}

.pdf_down .container>div {
    width: 90%;
    float: left;
    padding: 5%;
}

.section_container{
  
  min-height: 400px;
}

.content_area p {
    padding-bottom: 10%;
}
.swiper {
  width: 100%;
  /* height: 100%; */
   
}


.swiper-slide img {
  height: 100%;
    width: 100%;
 object-fit:scale-down;
}


.section img:not(.map img,nav img){

    background-size: cover;
    width: 100%;
    height: 100%;
 
}


.section nav img{
      height: 60px;
    height: 60px;
}


.videoArea{
width: 100%;
}


.left_area{
  width: 100%;
}

.right_area{
  width: 100%;
}
.section_container{
  width: 100%;
  display: block;
  /* float: left; */
}
.content_area{
  width: 100%;
}

.section_container>div{
/* float: left ; */
}



.left_area>div{
width: auto;
float: left;
}

.local h6{
  font-size: 20px;
}
.localMap .content{
  line-height: normal;
}

.localMap div{
  margin-top: 8%;
}



}









@media   (min-width:1024px){


.imagebook  .img{
  width: auto;
}
.wrap-contact100 p{
  text-align: left;
  color: white;
  padding-left: 5%;
}

textarea.input100 {
  min-height: 169px;
  padding: 20px 58px 0 35px;
}


.localMap>div  {

margin-top: 2%;

}


.bay>div:nth-child(1){
width: 29%;
}
    
.flex-column {
    flex-direction: column !important;
}
    .box input[type=text]{
        width:450px
    }

    .box button{
        width:200px ;
    }

    .box{
        width: 35%;
        
        left: 20%;
        right: 20%;
    }


    .imagebook .title{
      
      margin-top: 8.5%;

    }


}


</style>
